<template>
  <svg class="trash-icon" xmlns="http://www.w3.org/2000/svg" width="11.304" height="13">
    <g transform="translate(-5 -3)">
        <path data-name="Path 102" d="M13.967,18.174H8.642a1.131,1.131,0,0,1-1.124-1.006L6.5,8h9.609L15.09,17.168A1.131,1.131,0,0,1,13.967,18.174Z" transform="translate(-0.652 -2.174)" fill="#2699fb"/>
        <path data-name="Path 103" d="M15.739,5.13H5.565A.565.565,0,0,1,5,4.565H5A.565.565,0,0,1,5.565,4H15.739a.565.565,0,0,1,.565.565h0A.565.565,0,0,1,15.739,5.13Z" transform="translate(0 -0.435)" fill="#2699fb"/>
        <path data-name="Path 104" d="M15.391,4.13H12V3.565A.565.565,0,0,1,12.565,3h2.261a.565.565,0,0,1,.565.565Z" transform="translate(-3.043 0)" fill="#2699fb"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'TrashIcon'
  }
</script>

<style>

</style>